import { largeMediaQuery, mediumMediaQuery, smallMediaQuery } from './sizeHelpers';

import { withScreenSize } from './withScreenSize';
import { withLogging } from './withLogging';
import { storage } from './storage';

export const utilities = {
    withScreenSize,
    largeMediaQuery,
    mediumMediaQuery,
    smallMediaQuery,
    withLogging,
    storage
};
